import {LOCATION_CHANGE} from 'react-router-redux';
import {LOADS} from '~/routing/urls';

import A from './types';

const isLeaving = (fullState, action, path) =>
  fullState.routing.pathname.startsWith(path) && !action.payload.pathname.startsWith(path);

const initialState = {};

const reducer = (state, action, fullState) => {
  if (action.type === LOCATION_CHANGE
    && state.search && isLeaving(fullState, action, LOADS)) {
    return {search: null};
  }

  if (action.type !== A.SELECT_TAB) {
    return null;
  }

  return {[action.payload.id]: action.payload.selectedTab};
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/tabs/reducer.js